import type { Currency } from '@acme/domains';

export const ApplicationTitle = ({
  title,
  currency,
  amount,
}: {
  title: string;
  currency?: Currency | null;
  amount?: number | null;
}) => {
  const currencySymbol = currency?.symbol ?? '';

  return (
    <>
      <div className="flex items-center justify-between gap-6">
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold">{title}</h2>
        </div>

        <div className="text-right">
          {amount != null ? (
            <div className="text-xl font-semibold text-gray-900">
              {amount.toLocaleString('ru-RU')}
              <span className="ml-2  text-gray-500">
                {currencySymbol || currency?.name}
              </span>
            </div>
          ) : (
            <div className="text-xl font-semibold text-gray-900">-</div>
          )}
        </div>
      </div>
    </>
  );
};
